import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgxWeekdayPickerModule } from 'ngx-weekday-picker';
import { ComponentsModule } from 'src/app/components/components.module';

import { GatherDetailsPage } from './gather-details.page';

const routes: Routes = [
  {
    path: '',
    component: GatherDetailsPage
  }
]

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxWeekdayPickerModule,
    TranslateModule,
    BrowserModule,
    ComponentsModule,
    RouterModule.forChild(routes)
  ],
  declarations: [GatherDetailsPage]
})
export class GatherDetailsPageModule {}
